<ng-container *ngSubscribe="linkedCardsCount$ as linkedCardsCount">
  <ng-container *ngIf="linkedCardsCount <= 0">
    <div class="container">
      <button class="btn affiliate-link-your-card" [routerLink]="['/linkcard']">
        <span class="icon material-icons">credit_card</span>{{ 'affiliate-link-card-button-title' | translate }}
      </button>
    </div>
  </ng-container>
</ng-container>

<ul class="nav nav-secondary mixed-loyalty-nav shadow mt-0">
  <a
    class="nav-item card-linking-offer-nav"
    [routerLink]="['/affiliate/alloffers']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <label> {{ 'affiliate-tab-all-offers-text' | translate }}</label>
  </a>
  <a
    class="nav-item card-linking-offer-nav"
    [routerLink]="['/affiliate/myoffers']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <p>
      <label> {{ 'affiliate-tab-my-offers-text' | translate }}</label>
      <ng-container *ngIf="activatedOffersCount$ | async as activatedCount"
        ><span class="fw-normal">({{ activatedCount }})</span></ng-container
      >
    </p>
  </a>
</ul>

<router-outlet></router-outlet>
